<template>
  <span
    :style="containerStyle"
    :class="classNames"
    role="presentation"
    title="Подождите..."
  >
    <span :style="spinnerStyle" class="base-spinner__rotator"></span>
  </span>
</template>

<script>
export default {
  name: "BaseSpinner",
  props: {
    size: {
      type: String,
      default: "24px",
    },
    accent: {
      type: String,
      default: "#82368C",
    },
    color: {
      type: String,
      default: "transparent",
    },
    // "normal", "fast", "slow"
    speed: {
      type: String,
      default: "normal",
    },
    borderWidth: {
      type: String,
    },
    valign: {
      type: String,
    },
  },
  computed: {
    classNames() {
      const baseClass = "base-spinner";
      const { speed, valign } = this;
      const result = [baseClass, `${baseClass}--speed-${speed}`];
      if (valign) {
        result.push(`${baseClass}--valign-${valign}`);
      }
      return result;
    },
    containerStyle() {
      const { size } = this;
      return {
        width: size,
        height: size,
      };
    },
    spinnerStyle() {
      const { size, color, accent, borderWidth } = this;
      const width = parseInt(size, 10);
      return {
        borderWidth: borderWidth || Math.ceil(width * 0.1) + "px",
        borderColor: `${color} ${accent} ${accent} ${accent}`,
      };
    },
  },
};
</script>

<style lang="less">
.base-spinner {
  display: inline-block;
  width: 24px;
  height: 24px;
  position: relative;
  flex-grow: 0;
  flex-shrink: 0;
  will-change: transfrom;
  transform: translateZ(0);
  line-height: 1;

  &--valign-middle {
    vertical-align: middle;
  }
  &--valign-top {
    vertical-align: top;
  }
  &--valign-baseline {
    vertical-align: baseline;
  }

  &__rotator {
    display: block;
    border-style: solid;
    border-radius: 50%;
    width: 100%;
    height: 100%;
    animation: spinnerRotation 1s linear infinite both;
    transform-origin: center center;
  }

  &--speed-normal &__rotator {
    animation-duration: 1s;
  }

  &--speed-fast &__rotator {
    animation-duration: 0.5s;
  }

  &--speed-slow &__rotator {
    animation-duration: 2s;
  }
}

@keyframes spinnerRotation {
  to {
    transform: rotateZ(1turn);
  }
}
</style>
